import { definePermisos } from '../utils'

export const RESOURCE_CONTABILIDAD_PG = 'Contabilidad PG' as const

const permission = definePermisos(RESOURCE_CONTABILIDAD_PG, 'contabilidad-pg', {
    mantenimiento: {
        entidadesOrganizacionales: 'entidades-organizacionales',
        estadoPlanCuenta: 'estado-plan-cuenta',
        gestionCcSc: 'gestion-cc-sc',
        gestionModuloProcesoSubproceso: 'gestion-modulo-proceso-subproceso',
        maestroClaseCuenta: 'maestro-clase-cuenta',
    },
    configuracion: {
        diarioApertura: 'diario-apertura',
        permisosAdministracion: 'permisos-administracion',
        permisosTransacciones: 'permisos-transacciones',
        planCuenta: 'plan-cuenta',
        asignacionPermisos: 'asignacion-permisos',
    },
    transacciones: {
        cierreContable: 'cierre-contable',
        exportarDiario: 'exportar-diario',
        importarDiario: 'importar-diario',
        transaccionesContables: 'transacciones-contables',
    },
    informes: {
        anexos: 'anexos',
        anexosActivosFijos: 'anexos-activos-fijos',
        balanceComprobacion: 'balance-comprobacion',
        balanceComprobacionSegmentado: 'balance-comprobacion-segmentado',
        balanceDinamico: 'balance-dinamico',
        balanceGeneral: 'balance-general',
        conciliacionCuentas: 'conciliacion-cuentas',
        costoEmpacadoras: 'costo-empacadoras',
        costoTilapiero: 'costo-tilapiero',
        diarioGeneral: 'diario-general',
        estadoFinancieroSegmentado: 'estado-financiero-segmentado',
        estadoPyg: 'estado-pyg',
        indicadores: 'indicadores',
        mayorGeneral: 'mayor-general',
        mayorPatrimonio: 'mayor-patrimonio',
        mayorProcesos: 'mayor-procesos',
        movimientosContables: 'movimientos-contables',
        movimientosVentasCxC: 'movimientos-ventas-cxc',
        planCuenta: 'plan-cuenta',
        planCuentaCias: 'plan-cuenta-cias',
        planCuentaNiif: 'plan-cuenta-niif',
        resumenRentas: 'resumen-rentas',
    },
})

export default permission
